var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-loading"},[_c('img',{attrs:{"src":_vm.loading_spinner,"width":"60px","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }